export interface ErrorResponse {
  response: {
    status: number;
    data: {
      error: {
        display: string;
        system: string;
        inline?: string;
      };
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      [key: string]: any;
    };
    config: {
      url: string;
    };
  };
  code: string;
}

export interface GeneralResponse {
  message: string;
}


export enum PageTypes {
  CLINIC = "CLINIC",
  PATIENT = "PATIENT",
  USER = "USER",
  SETTINGS = "SETTINGS",
  NOT_FOUND = "NOT_FOUND",
  EVENT = "EVENT",
}

export enum EntityType {
  CLINIC = "clinic",
  EVENT = "event",
}



export interface Invitation {
  token: string;
  createdAt: string;
  expiresAt: string;
  role: string;
  roleId: number;
  status: string;
  company: {
    id: string;
    name: string;
    avatar: {
      image: string;
      initials: string;
      colorSchema: {
        background: string;
        text: string;
      };
    };
    website: string;
  };
  inviter: {
    firstName: string;
    lastName: string;
    avatar: {
      initials: string;
      colorSchema: {
        background: string;
        text: string;
      };
      image: string;
    };
    email: string;
  };
}


/*
|--------------------------------------------------------------------------
| Common User Type
|--------------------------------------------------------------------------
*/

export interface Timezone {
  id: string;
  label: string;
  offset: number;
  offsetDST: number;
  countries: string[];
  cities: string[];
}

export interface ColorSchema {
  background: string;
  text: string;
}

export interface Avatar {
  initials: string;
  colorSchema: ColorSchema;
  image?: string;
}

export enum UserPermissionAccess {
  CLINIC = "hasDentalClinic",
  EVENT = "hasEventCompany",
  RECORDS = "hasRecords",
  INVOICES = "hasInvoices",
}


/*
|--------------------------------------------------------------------------
| Common User Management Type
|--------------------------------------------------------------------------
*/


export interface UserPermissions {
  role: string;
  list: string[];
  roleId: number;
  createdAt?: string;
}



/*
|--------------------------------------------------------------------------
| Common Country Type
|--------------------------------------------------------------------------
*/

export interface Country {
  name: string;
  iso2: string;
  iso3: string;
  png: string;
  svg: string;
  phoneCountryCode: string;
  taxRate: number;
}


/*
|--------------------------------------------------------------------------
| Common Select Option Type
|--------------------------------------------------------------------------
*/

/**
 * Generic option type for dropdowns, select fields, and filters.
 * Can be used with different value types (string, number, etc.)
 */
export interface SelectOption<T = string> {
  label: string;
  value: T;
  description?: string;
  displayOrder?: number;
}

/*
|--------------------------------------------------------------------------
| Common Orgianziation
|--------------------------------------------------------------------------
*/


export enum HealthcareCompanyType {
  DENTAL_CLINIC = 'dental_clinic',
  DENTAL_LAB = 'dental_lab',
  EVENT_ORGANIZER = 'event_organizer',
}


export interface HealthcareCompany {
  id: string;
  name: string;
  avatar: Avatar;
  type: HealthcareCompanyType;
  address: {
    country: string;
    countryISO3: string;
    summary: string;
  };
  userPermissions: UserPermissions;
  taxNumber: string;
  taxType: string;
  currency: string;
  actions: string[];
}
